import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function About() {
  const { t } = useTranslation('common');
  const [currentSlide, setCurrentSlide] = useState(0);

  const images = [
    {
      src: 'https://static.readdy.ai/image/44113e0bd02cf9d4b6e5b2a3bf2fb8ec/71d02aecb59d382b7ce123d310d7102c.jpeg',
      alt: 'Interior de Tienda La Bonita Market'
    },
    {
      src: 'https://static.readdy.ai/image/44113e0bd02cf9d4b6e5b2a3bf2fb8ec/8a7f898d96b57f3b089d8bbe00e1b3a1.jpeg',
      alt: 'Productos mexicanos en exhibición'
    },
    {
      src: 'https://static.readdy.ai/image/44113e0bd02cf9d4b6e5b2a3bf2fb8ec/bcc73131a494f996de680197c4a256be.jpeg',
      alt: 'Área de atención al cliente'
    },
    {
      src: 'https://static.readdy.ai/image/44113e0bd02cf9d4b6e5b2a3bf2fb8ec/b24647235d3910e6dafd4c687e562c7f.jpeg',
      alt: 'Variedad de productos latinos'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <section id="sobre-nosotros" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Carousel */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl w-full h-[800px] group">
              {/* Images */}
              {images.map((image, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-opacity duration-500 ${
                    index === currentSlide ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              ))}

              {/* Navigation Arrows */}
              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-all duration-300 hover:scale-110 z-10 cursor-pointer"
                aria-label="Imagen anterior"
              >
                <i className="ri-arrow-left-s-line text-2xl text-gray-800"></i>
              </button>
              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-all duration-300 hover:scale-110 z-10 cursor-pointer"
                aria-label="Siguiente imagen"
              >
                <i className="ri-arrow-right-s-line text-2xl text-gray-800"></i>
              </button>

              {/* Dots Indicator */}
              <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-10">
                {images.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                      index === currentSlide
                        ? 'bg-white w-8'
                        : 'bg-white/50 hover:bg-white/75'
                    }`}
                    aria-label={`Ir a imagen ${index + 1}`}
                  />
                ))}
              </div>

              {/* Image Counter */}
              <div className="absolute top-6 right-6 bg-black/50 text-white px-4 py-2 rounded-full text-sm font-semibold backdrop-blur-sm z-10">
                {currentSlide + 1} / {images.length}
              </div>
            </div>

            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gradient-to-br from-red-500 to-orange-500 rounded-2xl -z-10"></div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-block bg-red-100 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              {t('about_badge')}
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              {t('about_title')} <strong>{t('about_title_highlight')}</strong> {t('about_title_suffix')}
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>{t('about_p1')}</p>
              <p>{t('about_p2')}</p>
              <p>{t('about_p3')}</p>
              <p>{t('about_p4')}</p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-red-600 mb-1">500+</div>
                <div className="text-sm text-gray-600">{t('about_stat_products')}</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-orange-600 mb-1">4</div>
                <div className="text-sm text-gray-600">{t('about_stat_countries')}</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-yellow-600 mb-1">100%</div>
                <div className="text-sm text-gray-600">{t('about_stat_authentic')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
